"use strict";
import Vue from "vue";
Vue.directive("drag", {
  bind(el, binding, vnode, oldVnode) {
    const dialogHeaderEl = el.querySelector(".el-dialog__header");
    const dragDom = el.querySelector(".el-dialog");
    dragDom.style.cssText += "position:absolute;margin-top:calc( 100vh - 290px );";
    dialogHeaderEl.style.cssText += ";cursor:move;";
    dragDom.style.cssText += ";top:0px;";
    const sty = (() => {
      return (dom, attr) => getComputedStyle(dom, void 0)[attr];
    })();
    dragDom.onmousedown = (e) => {
      const disX = e.clientX - dialogHeaderEl.offsetLeft;
      const disY = e.clientY - dialogHeaderEl.offsetTop;
      const screenWidth = document.body.clientWidth;
      const screenHeight = document.documentElement.clientHeight;
      const dragDomWidth = dragDom.offsetWidth;
      const dragDomheight = dragDom.offsetHeight;
      const minDragDomLeft = dragDom.offsetLeft;
      const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;
      const minDragDomTop = dragDom.offsetTop;
      const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight;
      let styL = sty(dragDom, "left");
      let styT = sty(dragDom, "top");
      styL = +styL.replace(/\px/g, "");
      styT = +styT.replace(/\px/g, "");
      document.onmousemove = function(e2) {
        let left = e2.clientX - disX;
        let top = e2.clientY - disY;
        if (-left > minDragDomLeft) {
          left = -minDragDomLeft;
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft;
        }
        if (-top > minDragDomTop) {
          top = -minDragDomTop;
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop;
        }
        dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`;
      };
      document.onmouseup = function(e2) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    };
  }
});
